import { useFormTagStore } from "../stores/form-tag-store";

export function useFormTags() {
	const attachTag = useFormTagStore((store) => store.attach);
	const detachTag = useFormTagStore((store) => store.detach);
	const syncTags = useFormTagStore((store) => store.sync);

	return {
		attachTag,
		detachTag,
		syncTags,
	};
}
